export default __webpack_public_path__ + "static/media/3.957d429b.jpg";